import React, { useEffect } from 'react'
import { useState } from 'react'
import {
  Alert,
  AlertTitle,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  TextField,
  Autocomplete,
  Button,
  Grid,
  Typography
} from '@mui/material'
import { useHistory } from 'react-router-dom'
import popUpMessage from '../../config/popUpMsg.json'
import payloadCountry from '../../config/vendorPicklistApiPayload.json'
import api from '../../service/api';
import ProgressBar from '../progress/progressBar'
import jsondata from "../../config/NewHCOFormFields.json";
import useLocalStorage from '../../hooks/useLocalStorage'

function ConfirmationDialogRaw1(props) {
  const [popMsg] = useState(popUpMessage.globalSearch)
  const { option, open, vendor, entityType } = props
  const [value, setValue] = React.useState(
    props.selectedCountry
      ? {
        id: props.selectedCountry,
        name: props.selectedCountry,
        label: props.selectedCountry
      }
      : ''
  )
  const [noCountryError, setNoCountryError] = React.useState(false)
  const [noSpecialtyError, setNoSpecialtyError] = React.useState(false)
  const [countrySelect, setCountryselect] = useState()
  const [vendorCountry, setVendorCountry] = useState('')
  const [allCountry, setAllCountry] = useState('')
  const [primarySpecialty, setPrimarySpecialty] = useState(props.primarySpecialty ? props.primarySpecialty : [])
  const [otherSpecialty, setOtherSpecialty] = useState(props.otherSpecialty ? props.otherSpecialty : [])
  const [selectedSpecialityValue, setSelectedSpecialityValue] = useState(
    props.SelectedSpecialtyValue ? props.SelectedSpecialtyValue : ''
  )
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  let dropdown_vendor = []
  let new_hcp_all_sources_country = []
  let findUniqueValue = []
  let new_hco_lilly_sources_country = []
  useEffect(() => {
    //finding out all the countries value for vendor

    let resolvedOption = option;
    if (resolvedOption === undefined) {
      resolvedOption = Storage.getAllCountryList();
    }

    resolvedOption.map((filter, key) => {
      const IQVIA_US_condition = (filter.split('#')[1] == 'Veeva Network' || filter.split('#')[1] == 'IQVIA_US') && filter.split('#')[0] == 'United States'
      if (filter.split('#')[1] == 'IQVIA' || IQVIA_US_condition) {
        dropdown_vendor.push({
          id: filter,
          name: filter,
          label: filter.split('#')[0]
        })
      }
      if (filter.split('#')[1] == 'IQVIA' || !filter.includes('#') || filter.split('#')[1] == 'OPEN-DATA' || IQVIA_US_condition) {
        findUniqueValue.push(filter.split('#')[0])
      }
    })
    setVendorCountry(
      dropdown_vendor.sort((a, b) => {
        return a.label < b.label ? -1 : 1
      })
    )
    findUniqueValue = findUniqueValue
      .filter(
        (value, index, self) => index === self.findIndex(t => t === value)
      )
      .sort((a, b) => {
        return a > b ? 1 : -1
      })
    ////finding out all the countries value for EPH
    findUniqueValue.map((filter, key) => {
      new_hcp_all_sources_country.push({
        id: filter.split('#')[0],
        name: filter.split('#')[0],
        label: filter.split('#')[0]
      })
    })


    setAllCountry(new_hcp_all_sources_country)
    //logic for editing country, specialty values in new hcp component

    //country list for lillymanaged countried also including US and hybrid countries
    if(props.entity === 'HCO' && !jsondata.allow_override_dcr){
      option.map((filter, key) => {
        if (filter.split('#')[1] != 'IQVIA') {
          new_hco_lilly_sources_country.push({
            id: filter,
            name: filter,
            label: filter.split('#')[0]
          })
        }
      })

    
      // jsondata.hybrid_countries.forEach(country =>{
      //   const newItem = country
      //   if(!new_hco_lilly_sources_country.some(item => item.id === newItem.id)){
      //     new_hco_lilly_sources_country.push(newItem)
      //   }
      // })

      // for add US in HCO list country

      let usCountry = { id: 'United States', name: 'United States', label: 'United States' }
      new_hco_lilly_sources_country.push(usCountry)
      setAllCountry(
        new_hco_lilly_sources_country.sort((a, b) => {
          return a.label < b.label ? -1 : 1
        })
      )
    }
  }, []);

  function toProperCase(string) {
    return string
      .toLowerCase()  // Convert the entire string to lowercase first
      .split(/(\W+)/) // Split by non-word characters
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter
      .join('');  // Rejoin the string parts
  }

  // routing the pop up data to appropriate component also checking the values
  const handleOk = () => {
    let selectedSpecialty = [];
    if (!vendor) {
      selectedSpecialty.push(selectedSpecialityValue?.PrimarySpecialty?.[0]?.value);
    }
    if (
      vendor
        ? value !== null && value !== undefined
        : selectedSpecialityValue !== null &&
        selectedSpecialityValue !== undefined &&
        selectedSpecialityValue.PrimarySpecialty &&
        !noCountryError &&
        !noSpecialtyError
    ) {
      let source = selectedSpecialityValue?.PrimarySpecialty?.[0]?.value.split('#')[1]
      // if country is US set source based on the entity Type 
      let locationStateVendor = 'IQVIA'
      let vendorName = ''
      if (vendor) {
        vendorName = countrySelect.split('#')[1]
      }
      let isUS = false
      if (countrySelect) {
        if (countrySelect.includes('United States')){
          isUS = true
        }
      } else {
        if (props.selectedCountry && props.selectedCountry.includes('United States')){
          isUS = true
        }
      }
      if (isUS) {
        if (entityType == "HCO") {
          source = "IQVIA_US"
          locationStateVendor = 'IQVIA'
          vendorName = "IQVIA" // change to IQVIA (for case when vendor = true -> history.push)
        } else {
          source = "VNDR-VN"
          locationStateVendor = 'Veeva Network'
          vendorName = "Veeva Network" // change to VN (for case when vendor = true -> history.push)
        }
      }
      vendor
        ? history.push({
            pathname: `/vendor-search/`,
            state: {
              seletedCountry: countrySelect.split('#')[0],
              vendor: vendorName,
              user: props.user,
            }
          })
        : 
      history.push({
        pathname: `/new/${entityType == "HCO" ? "hco" : "hcp"}`,
        state: {
          country: countrySelect ? countrySelect : props.selectedCountry,            
          source: source, // selectedSpecialityValue?.PrimarySpecialty?.[0]?.value.split('#')[1],
          homePage_Lilly: true,
          newSpecialty: selectedSpecialityValue,
          iqviaSource: false,
          vendor: locationStateVendor,
          allSelectedSpecialty: selectedSpecialty.concat(selectedSpecialityValue?.OtherSpecialty?.[0]?.value || []),
          user: props.user,
          primarySpecialty: primarySpecialty,
          otherSpecialty: otherSpecialty,
        }
        }) 
    
      
      props.onOk()
    }else if(!noCountryError && countrySelect !== "United States" && countrySelect !== undefined && entityType == "HCO"){
      history.push({
        pathname: `/new/hco`,
        state: {
          country: countrySelect ? countrySelect : props.selectedCountry,
          source: 'MNGD-AFF',
          homePage_Lilly: true,
          iqviaSource: false,
          vendor: 'IQVIA',
          user: props.user,
        }
      })
      props.onOk()
    }
     else {
      if (value == null || value === '') {
        setNoCountryError(
          !(value !== null && value !== undefined && value.length > 0)
        );
      } else if (
        selectedSpecialityValue == null ||
        !selectedSpecialityValue.PrimarySpecialty
      ) {
        setNoSpecialtyError(true);
      }
    }
  };

  // function to check and set values to state
  const handleChange = (event, value, id) => {


    if(id === 'country' && value.id !== "United States" && entityType == "HCO"){
      if (value != null && value != '') {
        if (id == 'country') {
          var getPaylodCountry = payloadCountry.countries.find(
            res => res?.country_Name == value.label
          )
          setLoading(true)
          setCountryselect(value.id);
          setValue(value);
          setSelectedSpecialityValue('');
          setPrimarySpecialty('')
          setNoCountryError(false)
          setLoading(false)
        }
      } else {
        if (id == 'country' && (value == null || value == '')) {
          setNoCountryError(
            !(value !== null && value !== undefined && value.length > 0)
          )
          setValue('')
        }
      }
    } else {

      if (value != null && value != '') {
        if (id == 'country') {
          var getPaylodCountry = payloadCountry.countries.find(
            res => res?.country_Name == value.label
          )
          setLoading(true)


          api.getPickList((getPaylodCountry ? getPaylodCountry.key.payloadKey : value.label), undefined, undefined, undefined, undefined, langLocaleChange).then((res) => {
            let response = res.data[0]
            // use "spclty_vn" when country is United States and entity type is HCP (#IQVIA_US IQVIA HCO Project)
            if (value.label == 'United States' && entityType == "HCP") {
              setPrimarySpecialty(response?.HCP?.spclty_vn)
            } else {
              setPrimarySpecialty(response?.HCP?.spclty)
            }
            setLoading(false)
          }).catch((error) => {
            console.log(error)
            // let errorDetail = error;
            // let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            setLoading(false)
          })
          setCountryselect(value.id);
          setValue(value);
          setSelectedSpecialityValue('');
          setNoCountryError(false)
        } else if (id == 'PrimarySpecialty') {
          setOtherSpecialty(primarySpecialty.filter((res) => res != value))
          setSelectedSpecialityValue({
            ...selectedSpecialityValue,
            [id]: [{ value: value }]
          })
          if (selectedSpecialityValue.OtherSpecialty && selectedSpecialityValue.OtherSpecialty[0]['value'].length > 0) {
            let matchedSpecialtyIndex = selectedSpecialityValue.OtherSpecialty[0]['value'].findIndex((res) => res == value)
            if (matchedSpecialtyIndex != -1) {
              selectedSpecialityValue.OtherSpecialty[0]['value'].splice(matchedSpecialtyIndex, 1)
            }
          }
          setNoSpecialtyError(false)
        } else {
          setSelectedSpecialityValue({
            ...selectedSpecialityValue,
            [id]: [{ value: value }]
          })
        }
      } else {
        if (id == 'country' && (value == null || value == '')) {
          setSelectedSpecialityValue('')
          setNoCountryError(
            !(value !== null && value !== undefined && value.length > 0)
          )
          setValue('')
        } else if (id == 'PrimarySpecialty' && (value == null || value == '')) {
          setSelectedSpecialityValue('')
          setNoSpecialtyError(
            !(
              selectedSpecialityValue !== null &&
              selectedSpecialityValue !== undefined &&
              selectedSpecialityValue.length > 0
            )
          )
        } else {
          setSelectedSpecialityValue({
            ...selectedSpecialityValue,
            [id]: [{ value: value }]
          })
        }
      }
    }
  }

  const [langLocaleChange] = useLocalStorage('wglang_api')
  useEffect(() => {
    if(countrySelect){
      handleChange(undefined, value, 'country')
    }
  }, [langLocaleChange])

  return (
    <Dialog
      maxWidth={vendor ? 'xs' : entityType === 'HCO'? 'sm': 'md'}
      aria-labelledby='confirmation-dialog-title-1'
      open={open}
      keepMounted
      fullWidth
    >
      {option && option.length === 0 && (
        <Alert severity='error' className='container' id='dialog-content'>
          <AlertTitle>Something went wrong. Please try again later.</AlertTitle>
          <Button onClick={props.onCancel} className='tableMerge'>
            Back!
          </Button>
        </Alert>
      )}
      {option && option.length !== 0 && (
        <>
          <DialogTitle id='dialog-title'>
              <Typography sx={{color:"#DC3545", fontSize:"20px"}}>{vendor ?`Vendor Search` : `Add New ${props.entity}`}</Typography>
              <Typography sx={{color:"#707070", fontSize:"14px"}}> {vendor
              ? popMsg[0].iqviapopup.heading1
              : `${popMsg[0].iqviapopup.heading} with adding a new ${props.entity} `}</Typography>
          </DialogTitle>

          <DialogContent dividers id='dialog-content'>
            <Grid
              container
              direction='row'
              justifyContent='space-between'
              flex-wrap='wrap'
              alignItems='center'
            >
              <Grid item md={vendor || entityType=='HCO' ? 12 : 5.5} xs={12}>
                <Autocomplete
                  disableClearable
                  fullWidth
                  value={value ? value : []}
                  key={!props.manageAccess ? 'Country' : 'Group'}
                  options={vendor ? vendorCountry : allCountry}
                  onChange={(event, value) => {
                    handleChange(event, value, 'country')
                  }}
                  getOptionLabel={option => (option.label ? option.label : '')}
                  isOptionEqualToValue={(optionn, value) =>
                    optionn.id === value.id
                  }
                  id={!props.manageAccess ? 'Country' : 'Group'}
                  name={!props.manageAccess ? 'Country' : 'Group'}
                  renderInput={params => (
                    <TextField
                      {...params}
                      error={noCountryError}
                      label={!props.manageAccess ? 'Country' : 'Group'}
                      variant='standard'
                      helperText={
                        noCountryError ? 'Please Select One Option' : ' '
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <ProgressBar color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              {!vendor && (
                <>
                  {primarySpecialty?.length > 0 && !loading && (
                    <Grid item md={entityType=='HCO' ? 12 : 5.5} xs={12}>
                      <Autocomplete
                        fullWidth
                        value={
                          selectedSpecialityValue.PrimarySpecialty
                            ? selectedSpecialityValue.PrimarySpecialty[0].value
                            : ''
                        }
                        options={primarySpecialty.sort((a, b) => a.localeCompare(b))}
                        onChange={(event, value) => {
                          handleChange(event, value, 'PrimarySpecialty')
                        }}
                        getOptionLabel={option => toProperCase(option.split(' | ')[0])}
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        id='primary-Specialty'
                        name='primary-Specialty'
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option}>
                              {toProperCase(option.split(' | ')[0])}
                            </li>
                          )
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            error={noSpecialtyError}
                            label={'Primary Specialty'}
                            variant='standard'
                            helperText={
                              noSpecialtyError
                                ? 'Please Select One Option'
                                : ' '
                            }
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {selectedSpecialityValue.PrimarySpecialty && (
                    <Grid item md={12} xs={12}>
                      <Autocomplete
                        multiple
                        value={
                          selectedSpecialityValue.OtherSpecialty
                            ? selectedSpecialityValue.OtherSpecialty[0].value
                            : []
                        }
                        key='other-Specialty'
                        options={otherSpecialty.sort((a, b) => a.localeCompare(b))}
                        getOptionLabel={option => toProperCase(option.split(' | ')[0])}
                        onChange={(event, value) => {
                          handleChange(event, value, 'OtherSpecialty')
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option == value
                        }
                        id='other-specialty'
                        name='other-specialty'
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option}>
                              {toProperCase(option.split(' | ')[0])}
                            </li>
                          )
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={'Other Specialty'}
                            variant='standard'
                          />
                        )}
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </DialogContent>

          <DialogActions sx={{ mr: '15px' }}>
            {props.manageAccess === undefined && (
              <Button
                onClick={props.onCancel}
                color='error'
                variant='outlined'
                className='_wg-dynamic-text'
              >
                cancel
              </Button>
            )}
            {props.manageAccess && (
              <Button
                onClick={props.onCancel}
                color='error'
                variant='outlined'
                className='_wg-dynamic-text'
              >
                cancel
              </Button>
            )}
            <Button
              onClick={handleOk}
              color='error'
              variant='contained'
              className='_wg-dynamic-text'
            >
              Confirm
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default ConfirmationDialogRaw1
